import { type Dispatch , useCallback } from 'react'

import type { TagColor } from './tagging.types'
import type { TaggingAction } from './taggingReducer'

interface UseTagDispatchWrappersResult {
  enterEditMode: (rowId: string) => void
  exitEditMode: () => void
  setActiveEditorRowId: (rowId: string | null) => void
  setInputText: (text: string) => void
  setSelectedColor: (color: TagColor) => void
}

export const useTagDispatchWrappers = (
  dispatch: Dispatch<TaggingAction>,
): UseTagDispatchWrappersResult => {
  const enterEditMode = useCallback(
    (rowId: string) => {
      dispatch({ payload: { rowId }, type: 'ENTER_EDIT_MODE' })
    },
    [dispatch],
  )

  const exitEditMode = useCallback(() => {
    dispatch({ type: 'EXIT_EDIT_MODE' })
  }, [dispatch])

  const setInputText = useCallback(
    (text: string) => {
      dispatch({ payload: { text }, type: 'SET_INPUT_TEXT' })
    },
    [dispatch],
  )

  const setSelectedColor = useCallback(
    (color: TagColor) => {
      dispatch({ payload: { color }, type: 'SET_SELECTED_COLOR' })
    },
    [dispatch],
  )

  const setActiveEditorRowId = useCallback(
    (rowId: string | null) => {
      dispatch({ payload: { rowId }, type: 'SET_ACTIVE_EDITOR_ROW_ID' })
    },
    [dispatch],
  )

  return {
    enterEditMode,
    exitEditMode,
    setActiveEditorRowId,
    setInputText,
    setSelectedColor,
  }
}
